import { EnhancedTabs, TabItem } from 'components/enhanced/tabs/EnhancedTabs';
import { TenantPage } from 'layouts';
import { useTranslation } from 'react-i18next';
import TransportDocumentActiveForm from '../components/form/TransportActiveDocumentForm';
import { useTransportActiveDocument } from '../hooks/useTransportActiveDocument';
import { ActiveDDTProducts } from '../components/tabs/ActiveDDTProducts';
import { TransportActiveDocumentActions } from '../components/TransportActiveDocumentActions';
import { EnhancedDialog } from 'components/enhanced';

interface TransportActiveDocumentDetailProps {
  isSupplierDdt?: boolean;
  translationPrefix?: string;
}

export function TransportActiveDocumentDetail({
  isSupplierDdt = false,
  translationPrefix = 'pages.active-ddt.detail'
}: TransportActiveDocumentDetailProps) {
  const { t } = useTranslation();
  const store = useTransportActiveDocument(isSupplierDdt, translationPrefix);

  const tabConfig: TabItem[] = store
    ? [
        {
          label: t(`global.base-info`),
          component: (
            <TransportDocumentActiveForm
              onSubmit={store.updateDDT}
              transport_document={store.ddt}
              isUpdate={true}
              disableEdit={store.isDisabledEdit}
              isSupplierDdt={isSupplierDdt}
            />
          )
        },
        {
          label: t(`${translationPrefix}.products`),
          component: (
            <ActiveDDTProducts
              isSupplierDdt={isSupplierDdt}
              translationPrefix={translationPrefix}
              store={store}
            />
          )
        }
      ]
    : [];

  return (
    <TenantPage
      title={`${t(`${translationPrefix}.title`)} ${store.ddt?.ref}`}
      subtitle={
        store.ddt?.status !== 'SENT'
          ? t(`${translationPrefix}.subtitle`)
          : t(`${translationPrefix}.subtitle-finalized`)
      }
      entityCode={store.ddt?.ref}
      menuRight={
        <TransportActiveDocumentActions store={store} translationPrefix={translationPrefix} />
      }>
      <>
        <EnhancedTabs tabs={tabConfig} variant="scrollable" />
        {/* Dialog component to confirm finalization of the transport active document */}
        <EnhancedDialog
          open={store.confirmFinalizeDialog}
          title={t(`${translationPrefix}.finalize-dialog.title`)}
          onClose={() => store.setConfirmFinalizeDialog(false)}
          onSubmit={store.finalizeDdt}
          submitLabel={t('actions.confirm')}
          cancelLabel={t('actions.reset')}
          maxWidth="md">
          {t(`${translationPrefix}.finalize-dialog.message`)}
        </EnhancedDialog>
      </>
    </TenantPage>
  );
}

export default TransportActiveDocumentDetail;
